import { TrackingHandler } from '../tracking/TrackingHandler';
import { extractDomainParts, shiftSubdomain } from './extract-domain';
const PORTAL_PREFIX = 'portal.';
const DEVICE_OS = 'Other';
const LOGIN_HEADERS = {
    'Content-Type': 'application/json',
};
const DEFAULT_LOGIN_DOMAIN = window.location.hostname.length === 0 || window.location.hostname === 'localhost'
    ? ''
    : shiftSubdomain(extractDomainParts(window.location.hostname));
const LOGIN_ENDPOINT = window.endpoints.login;
export const processLogin = async (username, password, deviceId, headers = {}, overrideLoginDomain = null, twoFactorCode = null, additionalUrlQueryString = '') => {
    const loginDomain = overrideLoginDomain || DEFAULT_LOGIN_DOMAIN;
    if (loginDomain.length < 5) {
        console.error('Cannot process login as login domain could not be determined');
    }
    console.log('Processing login', loginDomain);
    Object.assign(headers, LOGIN_HEADERS);
    const requestBody = {
        username,
        password,
        domain: 'https://' + loginDomain,
        grant_type: 'password',
        device_id: deviceId,
        device_os: DEVICE_OS,
        app_name: PORTAL_PREFIX + loginDomain,
    };
    if (twoFactorCode) {
        requestBody.twofactorcode = twoFactorCode;
    }
    const requestOptions = {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        body: JSON.stringify(requestBody),
        headers,
    };
    TrackingHandler.getInstance().setCustomer();
    return new Promise((resolve, reject) => {
        fetch(LOGIN_ENDPOINT, requestOptions)
            .then(async (response) => {
            const responseData = (await response.json());
            if (response.ok && responseData) {
                const successResponseData = responseData;
                const langQueryString = '?lang=' + (typeof window.page.language === 'string' ? window.page.language : 'en');
                const queryString = additionalUrlQueryString
                    ? langQueryString + '&' + additionalUrlQueryString
                    : langQueryString;
                const redirectUrl = successResponseData.redirect_url !== undefined
                    ? successResponseData.redirect_url + queryString
                    : 'https://' + PORTAL_PREFIX + loginDomain + queryString;
                window.top ? (window.top.location = redirectUrl) : (document.location = redirectUrl);
                resolve();
            }
            else {
                if (responseData) {
                    const errorResponseData = responseData;
                    reject(errorResponseData.reason);
                }
                reject();
            }
        })
            .catch((error) => {
            console.error('Error while trying to login', error);
            reject();
        });
    });
};
